// 📦 Imports
import React from "react";
import DisLatexRender from "../../../../../layout/DisLatexRender";

export default function EquationBox({ question, answer, setAnswer, submitAnswer, setHasSubmitted, hasSubmitted, handleNext, questionNumber }) {

    return (
        <div
        className="graphPaperBox"
        >
        {question && (
        <div className="text-4xl">
            <DisLatexRender math={`${question.question}`} />

            {/* 🔢 Input field */}
            <div className="flex items-center justify-center space-x-2">
            <DisLatexRender math={`x=`} />
            <input
                type="text"
                inputMode="text"
                pattern="-?[0-9]*"
                value={answer}
                onChange={(e) => setAnswer(e.target.value)}
                onKeyDown={(e) => {
                if (questionNumber > 10) {
                } else {
                    if (e.key === "Enter") {
                    if (!hasSubmitted) {
                        submitAnswer();
                        setHasSubmitted(true);
                    } else {
                        handleNext();
                    }
                    }
                }
                }}
                className="border items-center border border-black rounded-lg w-[77px] p-2"
                autoFocus
            />
            </div>
        </div>
        )}
        </div>
    );
}